import i18n from 'services/base/i18n';

export default {
  address: () => i18n.pgettext('Pages|List Issues|View Issue|Malicious Address', 'Malicious Address'),
  host:    () => i18n.pgettext('Pages|List Issues|View Issue|Malicious Address', 'Affected Host'),
  action:  () => i18n.pgettext('Pages|List Issues|View Issue|Malicious Address', 'Enforced Action'),
};
